import { createFileRoute } from '@tanstack/react-router';
import { AdminRatesPage } from '../../features/rates';

export const Route = createFileRoute('/admin/rates')({ component: AdminRatesPage });
